import React from 'react';
export const LimitsSummaryContainer = (props) => {
    const {t, element, listName, effectiveActiveIndex} = props;
    const list = element[listName];

    const renderItems = (list) => {
        let allSelected = false;
        if (list && list.length) {
            list.forEach((el) => {
                if(element.multienergeticSelected){
                    if (el.name === 'ALL' && el.selected) {
                        allSelected = true;
                    }
                }
            });
        }
        return (
            <div className='row fleet-good-group limmits-container'>
                {list && list.length
                    ? list.map((p, index) => {
                          const color = p.color ? p.color : 'white';
                          const fontColor = p.color ? 'white' : '#090E22';
                          return allSelected || p.selected ? (
                              <label
                                  key={`products-${p.name}-${index}`}
                                  className={`product-label card-details gray-border`}
                                  style={{backgroundColor: `${color}`, color: `${fontColor}`}}
                              >
                                  {t(`products.${p.name}`)}
                              </label>
                          ) : null;
                      })
                    : null}
            </div>
        );
    };
    const renderFleetGoodGroupLimit = (limitType) => {
        let limitName;
        if (effectiveActiveIndex === 0) {
            if (limitType === 'quantityLimit') {
                limitName = 'fuelQuantityLimit';
            } else if (limitType === 'amountLimit') {
                limitName = 'fuelAmountLimit';
            }
        } else if (effectiveActiveIndex === 2) {
            limitName = 'notFuelAmountLimit';
            limitType = 'amountLimit';
        } else if (effectiveActiveIndex === 1) {
            limitName = 'serviceAmountLimit';
            limitType = 'amountLimit';
        }
        return !!element && !!element[limitName] && element[limitName].type ? (
            <div className='col-12'>
                <div className='row'>
                    <label className='product-not-fuel-label'>
                        {`${t(`cards.${limitType}`)}: `}
                        {`${element[limitName].value}/${element[limitName].type === 'DAILY' ? t('day') : t('month')}`}
                    </label>
                </div>
            </div>
        ) : null;
    };
    return (
        <React.Fragment>
            <label className='p-label'>{t(`order-card.${listName}`)}:</label>
            {renderItems(list)}
            <label className='p-label mt-4'>{t(`order-card.limits.${listName}`)}:</label>
            <div className='row fleet-good-group limmits-container limits-summary'>
                {listName === 'petrols' ? renderFleetGoodGroupLimit('quantityLimit') : null}
                {renderFleetGoodGroupLimit('amountLimit')}
            </div>
        </React.Fragment>
    );
};
